module.exports = __webpack_public_path__ + "img/wifi.3e419251.png";